export async function Request<T>({
  method,
  url,
  data,
  headers,
}: {
  method: "GET" | "POST" | "PUT" | "DELETE";
  url: string;
  data?: any;
  headers?: Record<string, string>;
}): Promise<{ responseData: T | null; error: string | null }> {
  try {
    // Функция для санитизации строк: удаляет не-ASCII символы
    const sanitizeString = (str?: string): string | undefined => {
      if (!str) return undefined;
      return str
        .normalize('NFD') // Разбиваем символы с диакритикой
        .replace(/[\u0300-\u036f]/g, 'a') // Удаляем диакритические знаки
        .replace(/[^\x00-\x7F]/g, 'a'); // Удаляем не-ASCII символы
    };

    let requestHeaders: Record<string, string> = {
      "Content-Type": "application/json",
    };

    // Добавляем Telegram данные если доступны, санитизируя user
    if (window.Telegram?.WebApp?.initDataUnsafe) {
      const unsafeData = window.Telegram.WebApp.initDataUnsafe;
      const sanitizedData = {
        ...unsafeData,
        user: unsafeData.user
          ? {
              id: unsafeData.user.id,
              first_name: sanitizeString(unsafeData.user.first_name) || '',
              last_name: sanitizeString(unsafeData.user.last_name) || '',
              username: sanitizeString(unsafeData.user.username),
            }
          : undefined,
      };
      requestHeaders["X-Telegram-Init-Data"] = JSON.stringify(sanitizedData);
    }

    // Мержим с переданными заголовками
    if (headers) {
      requestHeaders = { ...requestHeaders, ...headers };
    }

    // Для GET запросов преобразуем data в query параметры
    let finalUrl = `https://bereg-turbaza.ru/api${url}`;
    if (method === "GET" && data) {
      const queryParams = new URLSearchParams();
      for (const [key, value] of Object.entries(data)) {
        if (value !== undefined) {
          queryParams.append(key, String(value));
        }
      }
      finalUrl += `?${queryParams.toString()}`;
    }

    const response = await fetch(finalUrl, {
      method,
      headers: requestHeaders,
      body: method !== "GET" && data ? JSON.stringify(data) : undefined,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Проверяем, что ответ является JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      throw new Error('Response is not JSON');
    }

    return {
      responseData: await response.json(),
      error: null,
    };
  } catch (err) {
    // Логируем тело ответа для отладки
    if (err instanceof Error && err.message.includes('HTTP error')) {
      try {
        const errorResponse = await fetch(`https://bereg-turbaza.ru/api${url}`).then((res) => res.text());
        console.error('Error response body:', errorResponse);
      } catch (logErr) {
        console.error('Failed to log error response:', logErr);
      }
    }
    return {
      responseData: null,
      error: err instanceof Error ? err.message : 'Unknown error',
    };
  }
}